import React, { useState } from "react";
import { IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

/**
 * `.input-main` password field with a show/hide toggle.
 *
 * The toggle is centred on the input itself (not on the surrounding grid cell,
 * whose label and padding vary), and the input reserves room on the right so
 * typed text never runs under the icon. Styles: .password-input in App.css.
 */
const PasswordInput = ({ className = "", ...inputProps }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className="password-input">
      <input
        {...inputProps}
        className={`input-main password-input__field ${className}`.trim()}
        type={visible ? "text" : "password"}
      />
      <IconButton
        size="small"
        className="password-input__toggle"
        onClick={() => setVisible((prev) => !prev)}
        aria-label={visible ? "Hide password" : "Show password"}
        title={visible ? "Hide password" : "Show password"}
      >
        {visible ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
      </IconButton>
    </div>
  );
};

export default PasswordInput;
